
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-cve",
      function () {
        return require("private-next-pages/search-cve.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search-cve"])
      });
    }
  